import type { useColorPickerInterface } from './interfaces'

export default function useColorPicker(): useColorPickerInterface {
  const getColorIfHexa = (color: string, hexa: string) => {
    return /^#[0-9A-F]{6}$/i.test(hexa) ? hexa : color
  }

  const isEyeDropperSupported = computed(() => typeof window !== 'undefined' && 'EyeDropper' in window)

  const useEyeDropper = async () => {
    if (!isEyeDropperSupported.value) {
      throw new Error('EyeDropper API not supported in this browser')
    }

    try {
      // @ts-expect-error - EyeDropper API might not be recognized by TypeScript
      const eyeDropper = new window.EyeDropper()
      return await eyeDropper.open()
    } catch (error) {
      console.error('Error using EyeDropper:', error)
      throw error
    }
  }

  return {
    getColorIfHexa,
    isEyeDropperSupported,
    useEyeDropper
  }
}
